(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.shopify-section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
};

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({note: event.target.value});
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  // --- INICIO DEL CÓDIGO AÑADIDO PARA EL BOTÓN DE RESERVA ---
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  const bookingButton = document.getElementById('prenotare-button');
  const recipientCheckbox = document.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"][type="checkbox"]');

  const durationPropertyInput = document.getElementById('LineItemProperty-DuracionTratamiento');

   if (productForm && durationPropertyInput && typeof variantDurations !== 'undefined') {
    function updateDurationProperty() {
      const selectedVariantInput = productForm.querySelector('[name="id"]');
      if (selectedVariantInput) {
        const selectedVariantId = selectedVariantInput.value;
        const duration = variantDurations[selectedVariantId] || ''; // Usamos la variable global
        durationPropertyInput.value = duration;
        // console.log(`[DEBUG - Propiedad de Línea] Duración de la variante seleccionada: ${duration}`);
      }
    }
    productForm.addEventListener('change', updateDurationProperty);
    updateDurationProperty();
  } else {
    // console.warn('[ADVERTENCIA - Propiedad de Línea] Elementos necesarios no encontrados o variantDurations no definida.');
  }

  // Verifica que todos los elementos existan
  if (!productForm || !bookingButton || !recipientCheckbox) {
    if (bookingButton) {
        bookingButton.classList.add('hide-prenotare-button');
    }
    return;
  }

  // Función para obtener la fecha actual en formato YYYY-MM-DD
  function getCurrentDateFormatted() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Función que actualiza el enlace y la visibilidad del botón
  function handleBookingButtonLogic() { // Renombrada para mayor claridad
    const selectedVariantInput = productForm.querySelector('[name="id"]');
    const selectedVariantId = selectedVariantInput ? selectedVariantInput.value : null;
    let baseBookingLink = selectedVariantId ? variantBookingLinks[selectedVariantId] : null;
    if (baseBookingLink) {
      const currentDate = getCurrentDateFormatted();
      if (baseBookingLink.includes('?')) {
        if (baseBookingLink.includes('date=')) {
            baseBookingLink = baseBookingLink.replace(/&date=[0-9]{4}-[0-9]{2}-[0-9]{2}/, `&date=${currentDate}`);
            baseBookingLink = baseBookingLink.replace(/\?date=[0-9]{4}-[0-9]{2}-[0-9]{2}/, `?date=${currentDate}`);
        } else {
            baseBookingLink += `&date=${currentDate}`;
        }
      } else {
        baseBookingLink += `?date=${currentDate}`;
      }
      bookingButton.href = baseBookingLink;
    } else {
      bookingButton.href = '#';
    }
    if (recipientCheckbox.checked || !baseBookingLink) {
      bookingButton.classList.add('hide-prenotare-button'); // Ocultar
    } else {
      bookingButton.classList.remove('hide-prenotare-button'); // Mostrar
    }
  }

  // Event Listeners
  productForm.addEventListener('change', handleBookingButtonLogic); // Cambios de variante
  recipientCheckbox.addEventListener('change', handleBookingButtonLogic); // Cambios en el checkbox del destinatario

  // Llamada inicial al cargar la página para establecer el estado correcto
  // Esto ocultará el botón inicialmente si no debería verse, o lo mostrará si cumple las condiciones.
  handleBookingButtonLogic();

  // --- INICIO DEL CÓDIGO AÑADIDO PARA EL POPUP DE REDIRECCIÓN ---

if (bookingButton) {
  bookingButton.addEventListener('click', function(event) {
    // 1. Prevenir la redirección inmediata del enlace
    event.preventDefault();

    const redirectUrl = this.href;

    // Si el enlace no es válido (ej. '#'), no hacer nada
    if (!redirectUrl || redirectUrl.endsWith('#')) {
      return;
    }

    // 2. Crear y mostrar el popup
    const popupOverlay = document.createElement('div');
    popupOverlay.id = 'redirect-popup-overlay';
    popupOverlay.innerHTML = `
      <div id="redirect-popup-modal">
        <p>${popupMessage}</p> 
      </div>
    `;
    document.body.appendChild(popupOverlay);

    // 3. Esperar 2.5 segundos y luego abrir la nueva pestaña
    setTimeout(() => {
      window.open(redirectUrl, '_blank');
      // Opcional: eliminar el popup después de la redirección
      popupOverlay.remove();
    }, 2500); // 2500 milisegundos = 2.5 segundos
  });
}
  // --- FIN DEL CÓDIGO AÑADIDO ---
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
